import { CspConfig } from './cspConfig.types';

const getCaseInsensitiveField = (row: CspConfig, field: keyof CspConfig): string | undefined => {
  const responseRow = row as unknown as Record<string, unknown>;
  const responseField = Object.keys(responseRow).find((key) => key.toLowerCase() === field.toLowerCase());
  const value = responseField == null ? undefined : responseRow[responseField];

  return typeof value === 'string' ? value : undefined;
};

/** Normalize a raw Xcipio CSP response row to the field names used by the UI. */
export const adaptCspConfig = (row: CspConfig): CspConfig => ({
  cspid: getCaseInsensitiveField(row, 'cspid') ?? '',
  name: getCaseInsensitiveField(row, 'name') ?? '',
  legalcontact: getCaseInsensitiveField(row, 'legalcontact'),
  nwcontact: getCaseInsensitiveField(row, 'nwcontact'),
});

export const adaptCspConfigs = (rows: CspConfig[]): CspConfig[] => rows.map(adaptCspConfig);
